/**
 * La candidature du tuteur : ses routes poussées et son onglet d'accueil, pour le candidat seulement
 * (`tutorCandidateRoutes`, `tutorCandidateTabs`).
 *
 * - l'onglet `dashboard` : la page de candidature, le parcours en un seul chemin ;
 * - `intro` : l'intro du champion d'une étape (l'élève et le visiteur gardent l'ancien écran) ;
 * - `application-personal-infos` : le profil ;
 * - `application-interview` : les entretiens, écrits et vidéo ;
 * - `video-recording` : l'enregistrement d'une réponse vidéo.
 * La fin d'une étape est une page de l'écran qui l'envoie (`congrats` reste à l'ancien code).
 *
 * Chaque écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { type TutorCandidateRouteTable, type TutorCandidateTabTable } from "../tutorSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const applicationRoutes: TutorCandidateRouteTable = {
    intro: loadedOnRender(
        () => require("./TutorApplicationIntroScreen").TutorApplicationIntroScreen,
        "TutorApplicationIntroScreen"
    ),
    "application-personal-infos": loadedOnRender(
        () => require("./TutorApplicationProfileScreen").TutorApplicationProfileScreen,
        "TutorApplicationProfileScreen"
    ),
    "application-interview": loadedOnRender(
        () => require("./TutorApplicationInterviewScreen").TutorApplicationInterviewScreen,
        "TutorApplicationInterviewScreen"
    ),
    "video-recording": loadedOnRender(
        () => require("./TutorApplicationRecordingScreen").TutorApplicationRecordingScreen,
        "TutorApplicationRecordingScreen"
    ),
}

export const applicationTabs: TutorCandidateTabTable = {
    dashboard: loadedOnRender(
        () => require("./TutorApplicationScreen").TutorApplicationScreen,
        "TutorApplicationScreen"
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
